import { Controller } from "@hotwired/stimulus"

// Steps through a replayed incident one moment at a time: each step is a "panel", with a "tab" in
// the list beside it, and only the current one is shown. Without JavaScript every panel is simply
// on the page in order, so the replay still reads top to bottom.
export default class extends Controller {
  static targets = ["panel", "tab", "previous", "next", "position"]
  static values = { index: { type: Number, default: 0 } }

  select(event) {
    this.indexValue = Number(event.currentTarget.dataset.index)
  }

  next() {
    this.indexValue = Math.min(this.indexValue + 1, this.panelTargets.length - 1)
  }

  previous() {
    this.indexValue = Math.max(this.indexValue - 1, 0)
  }

  indexValueChanged() {
    const last = this.panelTargets.length - 1
    this.panelTargets.forEach((panel, index) => { panel.hidden = index !== this.indexValue })
    this.tabTargets.forEach((tab, index) => {
      tab.classList.toggle("active", index === this.indexValue)
      if (index === this.indexValue) {
        tab.setAttribute("aria-current", "step")
      } else {
        tab.removeAttribute("aria-current")
      }
    })
    if (this.hasPreviousTarget) this.previousTarget.disabled = this.indexValue === 0
    if (this.hasNextTarget) this.nextTarget.disabled = this.indexValue === last
    if (this.hasPositionTarget) this.positionTarget.textContent = `Step ${this.indexValue + 1} of ${last + 1}`
  }
}
